import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "../components/AppShell/AppShell";
import HomePage from "../pages/Home/Home";
import ValveControl from "../pages/valveControl/ValveControl";
import Alerts from "../pages/Alerts/Alerts";
import Profile from "../pages/profile/Profile";
import Recommendations from "../pages/Recommendations/Recommendations";
import WaterHistory from "../pages/WaterHistory/WaterHistory";
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import NewPasswordRequired from "../pages/NewPasswordRequired/NewPasswordRequired";
import ConfirmEmail from "../pages/ConfirmEmail/ConfirmEmail";
import LandingInfo from "../pages/LandingInfo/LandingInfo";
import Devices from "../pages/Devices/Devices";
import LinkDevice from "../pages/LinkDevice/LinkDevice";
import Subscription from "../pages/Subscription/Subscription";
import authService from "../services/auth";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  return !isAuthenticated ? children : <Navigate to="/home" replace />;
};

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route
          path="/new-password-required"
          element={<NewPasswordRequired />}
        />
        <Route
          path="/confirm-email"
          element={<ConfirmEmail />}
        />
        <Route
          path="/info"
          element={<LandingInfo />}
        />

        {/* Rutas privadas - todas envueltas por el AppShell */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <AppShell>
                <Routes>
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/simulated" element={<Navigate to="/home" replace />} />
                  <Route path="/valve-control" element={<ValveControl />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/history" element={<WaterHistory />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/recommendations" element={<Recommendations />} />
                  <Route path="/devices" element={<Devices />} />
                  <Route path="/devices/link" element={<LinkDevice />} />
                  <Route path="/subscription" element={<Subscription />} />
                  <Route path="/" element={<Navigate to="/home" replace />} />
                </Routes>
              </AppShell>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
